import { render, staticRenderFns } from "./mapBox.vue?vue&type=template&id=87be2e0e&scoped=true&"
import script from "./mapBox.vue?vue&type=script&lang=js&"
export * from "./mapBox.vue?vue&type=script&lang=js&"
import style0 from "./mapBox.vue?vue&type=style&index=0&id=87be2e0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be2e0e",
  null
  
)

export default component.exports